import Inview             from './classes/Inview';
import Pluton             from 'whitecube-pluton';

class Telos {
    constructor() {
        this.parts = new Pluton();
        this.inview = Inview;
        
        document.querySelectorAll('.smoothlink').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                let currentUrl = new URL(window.location.href);
                console.log(this.getAttribute('href'));
                let url = new URL(this.getAttribute('href'));
                let el = document.querySelector(url.hash);

                if(url.pathname != currentUrl.pathname) return;
                if(!el) return;
                
                e.preventDefault();
                el.scrollIntoView({
                    behavior: 'smooth'
                });
                

            });
        });

        this.setEvents();
    }
    

    setEvents() {
        window.addEventListener("pluton-setup", this.e_plutonSetup.bind(this))
    }

    e_plutonSetup(e) {
        console.log('pluton-setup', e.detail.el);
        this.parts.setup(e.detail.el);
    }
}

window.addEventListener("load", function(event) {
    window.Telos = new Telos();
});

window.initMap = () => {
    window.dispatchEvent(new CustomEvent('telos-mapsloaded'));
    window.mapsLoaded = true;
}
